import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import "./NotFound.css";
import { useTheme } from "../../Hooks/useTheme";
import { ROUTES } from "../../Constants/Routes";

const NotFound: React.FC = () => {
  const { theme } = useTheme();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  return (
    <div className={`notfound-wrapper ${theme} ${visible ? "visible" : ""}`}>
      <div className="notfound-container">
        {/* Floating Glow Orb */}
        <div className="notfound-orb"></div>

        {/* Company Name */}
        <div className="nf-company">
          <span className="company-main">LICO Technologies</span>
          <span className="company-sub">Learn and Innovate</span>
        </div>

        {/* 404 */}
        <h1 className="nf-404">404</h1>

        {/* Title */}
        <h2 className="nf-title">Oops! Page Not Found</h2>

        {/* Description */}
        <p className="nf-desc">
          Looks like you've wandered off the learning path. Let’s get you back
          to innovation.
        </p>

        {/* Buttons */}
        <div className="nf-actions">
          <RouterLink to={ROUTES.HOME.path} className="nf-btn primary">
            Go Home
          </RouterLink>

          <RouterLink to={ROUTES.CONTACTUS.path} className="nf-btn secondary">
            Contact Support
          </RouterLink>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
